import { gql } from "@at/sauron-platform-graphql";

export const leasingVehicleSummaryListQuery = gql`
  query LeasingVehicleSummaryListQuery(
    $advertId: String!
    $leaseOption: String
  ) {
    search {
      advert(advertId: $advertId, leaseOption: $leaseOption) {
        id
        specification {
          doors
          bodyType
          fuel
          transmission
          seats
          battery {
            range {
              range
              unit
            }
          }
        }
      }
    }
  }
`;
